import { orderBy } from 'lodash'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import IWGenericTable from 'shared/components/thunderbolt/IWGenericTable'
import IWLoading from 'shared/components/thunderbolt/IWLoading'
import IWTypography from 'shared/components/thunderbolt/IWTypography'
import { WizardStepProps } from 'shared/types'
import styled from 'styled-components'
import { lsInternalBilateralTableSchema } from '../schemas'
import { IbtCsvRowItem } from '../types'

const StyledActionableSection = styled.div`
  display: flex;
  flex-direction: column;

  & > :first-child {
    margin-bottom: 0.25rem;
  }
`

const tableColumns = lsInternalBilateralTableSchema

type TableItem = IbtCsvRowItem

type StepState = {
  internalBilaterals: IbtCsvRowItem[]
}

export type Props = WizardStepProps<StepState>

export default function LSSubmissionPreviewIBT({ state, onChange }: Props) {
  const { t } = useTranslation()
  const internalBilaterals = state?.internalBilaterals || []
  const [items, setItems] = useState<TableItem[]>([])
  const [updatedTableItems, setUpdatedTableItems] = useState<TableItem[]>([])
  const [isLoading, setIsLoading] = useState(true)

  const toTableItems = (ibtItems: IbtCsvRowItem[]) => {
    const orderedItems = orderBy(ibtItems || [], [
      ['market', 'brand', 'zone', 'date', 'buyer', 'seller'],
    ])
    return orderedItems as TableItem[]
  }

  useEffect(() => {
    if (internalBilaterals?.length) {
      setItems(toTableItems(internalBilaterals))
      setIsLoading(false)
    }
  }, [internalBilaterals])

  useEffect(() => {
    onChange(
      {
        internalBilaterals: updatedTableItems as IbtCsvRowItem[],
      },
      true,
    )
  }, [updatedTableItems])

  return (
    <>
      <StyledActionableSection>
        <IWTypography
          size="lg"
          weight="medium"
          fontHue={{ color: 'grey', value: 900 }}
        >
          {t('loadScheduling.titles.submissionPreview')}
        </IWTypography>

        <IWTypography fontHue={{ color: 'grey', value: 500 }} size="sm">
          {t('loadScheduling.descriptions.submissionPreview')}
        </IWTypography>
      </StyledActionableSection>

      {isLoading && <IWLoading />}

      {Boolean(internalBilaterals?.length) && !isLoading && (
        <IWGenericTable
          border
          items={items}
          columns={tableColumns}
          pinnedColumns={{ brand: 'left' }}
          showColumnSettings
          onTableItemsUpdated={(updatedItems) => {
            setUpdatedTableItems(updatedItems)
          }}
        />
      )}
    </>
  )
}
